module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAPJJREFUOE/tkqFOxEAQhv/Z0PAAvAAJwZ+5BIXAIRAYLAEzO32Gc7xC085WEcwFh8AicKB4A+4u4Rkwd90hbSipuFRAcV21I74vM/8MYeBHA/swCv+e6JjhmOEvEvi/s1HVQyKaAnhg5s+2uRBCYmZnZrYQkbdu09uYpsOyLCdm9gJgF8ArMx+1oKreE9EFgE2M8VxEHvuYRqiqMyK6aSVVVR2kafpe1yGENYCd+m9md977yz6mERZFceKce/oWrph5vzPyM4Djuo4xXonIbR/zs5Q8z0+dc/XocxFZtsIsy/aSJLk2sw/v/byb4TZm8C1/AfuzcBWBMCaPAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/more1.png
// module id = soWu
// module chunks = 10